import { z } from "zod";

const schema = z.object({
  hasFundraisingExperience: z.boolean().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateFundraisingFormSchema,
  type Schema as CandidateFundraisingFormSchema,
};
